import { Routes } from 'types/global.type';

export const protectedRoutes = [Routes.home];
